module.exports = __webpack_public_path__ + "static/Irwin-Gill-Driving-70e4df81dcf0265f2e7f545f44e3e0fe.jpg";